import {Component, OnInit} from '@angular/core';
import {CpProvisionContractBaseComponent} from '../base/cp-provision-contract-base.component';

/**
 * Side view of the Provisionszeile OBC (`uiMode = 'side' | 'mini-side'`).
 *
 * Narrow by design: the default stacks Basisdaten and Berechnung, because those two answer the
 * question the side panel is opened for. The wide Provisionssätze table stays reachable through
 * `?sideNavItem=`.
 */
@Component({
    selector: 'cp-provision-contract-side',
    templateUrl: './cp-provision-contract-side.component.html',
    styleUrls: ['./cp-provision-contract-side.component.scss'],
    standalone: false
})
export class CpProvisionContractSideComponent extends CpProvisionContractBaseComponent
    implements OnInit {

    ngOnInit() {
        super.ngOnInit();
    }

}
